import { api } from "@/lib/api";

// Web Push foundation (UAT prompt #17).
// This builds the full client subscription path so that when a VAPID public key
// and a sending service are configured server-side, drop-off reminders can be
// delivered. Until a key is present, `pushAvailable()` is false and we never
// prompt or subscribe — nothing is faked.

export function pushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushAvailable(config) {
  return pushSupported() && !!config?.vapid_public_key;
}

export function pushPermission() {
  return pushSupported() ? Notification.permission : "unsupported";
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function enablePush(config) {
  if (!pushAvailable(config)) throw new Error("Push notifications aren't available yet.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications were not allowed.");

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(config.vapid_public_key),
    });
  }
  const json = sub.toJSON();
  await api.driverPushSubscribe({
    endpoint: sub.endpoint,
    p256dh: json.keys?.p256dh || null,
    auth: json.keys?.auth || null,
    user_agent: navigator.userAgent,
  });
  return true;
}
